import React, { HTMLAttributes } from 'react';
import { cva } from 'class-variance-authority';
import styles from './Eyebrow.module.css';

const eyebrow = cva(styles.eyebrow, {
  variants: {
    styleVariant: {
      inspiration: styles.inspiration,
      collect: styles.collect,
      spend: styles.spend,
      activate: styles.activate,
    },
  },
  defaultVariants: {
    styleVariant: 'inspiration',
  },
});

export interface EyebrowProps
  extends HTMLAttributes<
    HTMLSpanElement | HTMLParagraphElement | HTMLHeadingElement
  > {
  /**
   * The text content of the Eyebrow component.
   * This is the main content that will be displayed.
   */
  children: React.ReactNode;
  /**
   * As which HTML element to render the Eyebrow component.
   * This allows for flexibility in the semantic structure of the document.
   * @default 'span'
   */
  as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  /**
   * Style variant of the Eyebrow component.
   * This determines the visual style applied to the component.
   * @default 'inspiration'
   */
  styleVariant?: 'inspiration' | 'collect' | 'spend' | 'activate';
}

export const Eyebrow = ({
  children,
  as: Component = 'span',
  styleVariant = 'inspiration',
  ...props
}: EyebrowProps) => {
  return (
    <Component className={`${eyebrow({ styleVariant })} ''}`} {...props}>
      {children}
    </Component>
  );
};

export default Eyebrow;
